import * as PlansActionTypes from 'actiontypes/plans';
import PlansService from 'services/PlansService';
import { IPlan } from 'types/plans';

const plansService = new PlansService();


/** ----------------------------------------------------------------------------
 * FETCH PLANS
 -----------------------------------------------------------------------------*/
export default function fetchPlans() {
  return (dispatch: Function) => {
    dispatch(fetchPlansRequest());
    plansService.fetchPlans().then((response) => {
      dispatch(fetchPlansSuccess(response.data));
    }).catch((message) => {
      dispatch(fetchPlansFailure(message));
    });
  };
}

export const fetchPlansRequest = () => ({
  type: PlansActionTypes.FETCH_PLANS_REQUESTED,
  isFetching: true,
});

export const fetchPlansSuccess = (data: { active: IPlan[], complete: IPlan[] }) => ({
  type: PlansActionTypes.FETCH_PLANS_SUCCESS,
  isFetching: false,
  payload: {
    activePlans: data.active,
    completePlans: data.complete,
  },
});

export const fetchPlansFailure = (error: any) => ({
  type: PlansActionTypes.FETCH_PLANS_FAILURE,
  isFetching: false,
  error: true,
  status: error.response && error.response.status,
});